import React from 'react';
import ProgressBar from './ProgressBar';
import './UploadBanner.css';
import './Button.css';

const formatDuration = (seconds) => {
  if (isNaN(seconds) || seconds < 0) {
    return "0:00:00";
  }
  const h = Math.floor(seconds / 3600).toString(),
        m = Math.floor(seconds % 3600 / 60).toString().padStart(2, '0'),
        s = Math.floor(seconds % 60).toString().padStart(2, '0');
  return `${h}:${m}:${s}`;
};

const UploadBanner = ({ state, handleFileChange, uploadProgress, project, localVideoMeta }) => {
  if (state === 'no-video') {
    return (
      <>
        <input
          type="file"
          accept=".mp4"
          onChange={handleFileChange}
          id="video-upload"
          style={{ display: 'none' }}
        />
        <label htmlFor="video-upload" className="btn btn-teal capsule">
          Upload Video
        </label>
      </>
    );
  }

  if (state === 'uploading') {
    return (
      <div className="upload-banner uploading">
        <p>Uploading...</p>
        <ProgressBar progress={uploadProgress} />
      </div>
    );
  }

  if (state === 'uploaded') {
    const video = project.video || {};
    const fps = video.fps;
    const resolution = video.resolution || localVideoMeta?.resolution;
    const length = video.length || localVideoMeta?.length;
    const storagePath = video.storagePath;
    return (
      <div className="upload-banner">
        <div className="video-metadata">
          <div className="metadata-item">
            <span className="metadata-label">File Name</span>
            <span className="metadata-value">{(storagePath || '').split('/').pop() || '--'}</span>
          </div>
          <div className="metadata-item">
            <span className="metadata-label">FPS</span>
            <span className="metadata-value">{fps ? Math.round(fps) : '--'}</span>
          </div>
          <div className="metadata-item">
            <span className="metadata-label">Resolution</span>
            <span className="metadata-value">{resolution ? `${resolution.width}x${resolution.height}` : '--'}</span>
          </div>
          <div className="metadata-item">
            <span className="metadata-label">Duration</span>
            <span className="metadata-value">{length ? formatDuration(length) : '--'}</span>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default UploadBanner;
